import React from 'react';
import PropTypes from 'prop-types';

const Amenity = ({ icon, label }) => (
  <span className="amenity-chip">
    <span className={icon} aria-hidden="true" />
    <span className="amenity-chip-label">{label}</span>
  </span>
);

Amenity.propTypes = {
  slug: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default Amenity;
